/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {creditMultiStepPoll} from '../api'

export const useMutationCreditMultiStepPoll = createReactQueryMutationHook('creditMultiStepPoll', creditMultiStepPoll)
